import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { IconHit } from '../../../../../components/icons/IconHit';
import { TooltipRight } from '../../../../../components/TooltipRight';
import { FacilityGroupIcon } from '../../../../../services/mergeIconHotelFacilities';
import { ComponentJSSClasses } from './styles';

export interface FacilitiesListProps {
    facilitiesGroups: FacilityGroupIcon[];
}

interface StyledFacilitiesListProps extends FacilitiesListProps, JSSClassesProps<ComponentJSSClasses> { }

export class FacilitiesList extends React.Component<StyledFacilitiesListProps, {}> {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <p className={classes.header} >Все услуги отеля</p>
                {!this.props.facilitiesGroups.length && (
                    <p className={classes.emptyText}>Пока нет информации об&nbsp;услугах. Скоро исправим.</p>
                )}
                <ul className={classes.list}>
                    {this.props.facilitiesGroups.map(group => (
                        <li className={classes.facilityGroup} key={group.id}>
                            <p className={classes.title}>
                                <span className={classes.icon}>{group.icon}</span>
                                <b className={classes.title_name}>{group.groupName}:</b>
                            </p>
                            {group.facilities.map(f => (
                                <div key={f.id} className={classes.text}>
                                     <span style={{verticalAlign: 'middle'}} >{f.name}</span>
                                     {f.extraCharge && <TooltipRight icon={<IconHit />} text={<span>За дополнительную плату</span>} />}
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
